import {FC, ReactNode, useState} from "react";
import {BASE_DISCIPLINE_COLOR} from "../../constants/courseTypes";
import styled from "styled-components";
import {FlexBox} from "@brg/ui";
import {LayoutConst} from "../../../core";
import {ProjectCardTitle} from "../projectCard/styles";
import {LmsTitle} from "../TeamCard/TeamCard";
import {useGetLMSDisciplines} from "../../hooks/api/LMS/useGetLMSDisciplines";
import {getDisciplineColorFromId} from "../../helpers/LMS/getDisciplineColorFromId";
import {useSelector} from "react-redux";
import {OrganizationsState} from "../../reducers/OrganizationsSlice";
import { Project } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useTeam } from "shared/hooks/useTeam";

const Wrapper = styled(FlexBox)<{color?: string}>`
    width: 100%;
    height: 100%;
    padding: 32px 48px;
    background-color: ${({color}) => color ? color : BASE_DISCIPLINE_COLOR};

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      padding: 24px;
    }
  
    @media(max-width: ${LayoutConst.screen.m}px) {
      padding: 16px;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
      padding: 8px;
    }

  ${ProjectCardTitle}, ${LmsTitle} {

    font-size: 30px!important;
    font-style: normal;
    font-weight: 600;
    line-height: 40px!important;
    letter-spacing: -0.02em;
    padding: 0px!important;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 26px!important;
      line-height: 32px!important;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      font-size: 17px!important;
      line-height: 22px!important;
    }
  }
`;


export const LMSModuleCover: FC<{title?: ReactNode, discipline?: string, color?: string, style?: any, project?: Project<'Global'> | Project<'Local'>}> = ({title, style = {}, discipline = '', color, project}) => {

    const storedTeam = useSelector((store: { organizations: OrganizationsState }): OrganizationsState => store.organizations.team);
    const excludedContexts = ["lmsproject", "lmshseproject", "hsedesign"];
    const matchingContext = project?.contexts?.find(
      (context) => !excludedContexts.includes(context)
    );
    const [date] = useState(Date.now());
    const { i18n } = useTranslation();
    const disableRequest = !!storedTeam?.teamId;
    const team = useTeam(matchingContext || '', date , i18n.language, disableRequest)
    const { colors: disciplineColors } = useGetLMSDisciplines(storedTeam?.teamId || team?.teamId || '') 

    return <Wrapper style={style} color={color || getDisciplineColorFromId(discipline, disciplineColors)}>
        {title}
    </Wrapper>
}import {FC, ReactNode, useState} from "react";
import {BASE_DISCIPLINE_COLOR} from "../../constants/courseTypes";
import styled from "styled-components";
import {FlexBox} from "@brg/ui";
import {LayoutConst} from "../../../core";
import {ProjectCardTitle} from "../projectCard/styles";
import {LmsTitle} from "../TeamCard/TeamCard";
import {useGetLMSDisciplines} from "../../hooks/api/LMS/useGetLMSDisciplines";
import {getDisciplineColorFromId} from "../../helpers/LMS/getDisciplineColorFromId";
import {useSelector} from "react-redux";
import {OrganizationsState} from "../../reducers/OrganizationsSlice";
import { Project } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useTeam } from "shared/hooks/useTeam";

const Wrapper = styled(FlexBox)<{color?: string}>`
    width: 100%;
    height: 100%;
    padding: 32px 48px;
    background-color: ${({color}) => color ? color : BASE_DISCIPLINE_COLOR};

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      padding: 24px;
    }
  
    @media(max-width: ${LayoutConst.screen.m}px) {
      padding: 16px;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
      padding: 8px;
    }

  ${ProjectCardTitle}, ${LmsTitle} {

    font-size: 30px!important;
    font-style: normal;
    font-weight: 600;
    line-height: 40px!important;
    letter-spacing: -0.02em;
    padding: 0px!important;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 26px!important;
      line-height: 32px!important;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      font-size: 17px!important;
      line-height: 22px!important;
    }
  }
`;


export const LMSModuleCover: FC<{title?: ReactNode, discipline?: string, color?: string, style?: any, project?: Project<'Global'> | Project<'Local'>}> = ({title, style = {}, discipline = '', color, project}) => {

    const storedTeam = useSelector((store: { organizations: OrganizationsState }): OrganizationsState => store.organizations.team);
    const excludedContexts = ["lmsproject", "lmshseproject", "hsedesign"];
    const matchingContext = project?.contexts?.find(
      (context) => !excludedContexts.includes(context)
    );
    const [date] = useState(Date.now());
    const { i18n } = useTranslation();
    const disableRequest = !!storedTeam?.teamId;
    const team = useTeam(matchingContext || '', date , i18n.language, disableRequest)
    const { colors: disciplineColors } = useGetLMSDisciplines(storedTeam?.teamId || team?.teamId || '') 

    return <Wrapper style={style} color={color || getDisciplineColorFromId(discipline, disciplineColors)}>
        {title}
    </Wrapper>
}